export const DEFAULT_SWATCHES = [
  // id: 1 is treated specially in ColorPicker — rendered first with a line break after it
  { id: 1, name: 'None / transparent', value: '' },

  // Neutrals
  { id: 2, name: 'Black', value: '#000000' },
  { id: 3, name: 'Dark grey', value: '#374151' },
  { id: 4, name: 'Grey', value: '#6B7280' },
  { id: 5, name: 'Light grey', value: '#D1D5DB' },
  { id: 6, name: 'White', value: '#FFFFFF' },

  // Reds
  { id: 7, name: 'Red 900', value: '#7F1D1D' },
  { id: 8, name: 'Red 600', value: '#DC2626' },
  { id: 9, name: 'Red 300', value: '#FCA5A5' },

  // Oranges
  { id: 10, name: 'Orange 900', value: '#7C2D12' },
  { id: 11, name: 'Orange 600', value: '#EA580C' },
  { id: 12, name: 'Orange 300', value: '#FDBA74' },

  // Yellows
  { id: 13, name: 'Yellow 900', value: '#713F12' },
  { id: 14, name: 'Yellow 500', value: '#EAB308' },
  { id: 15, name: 'Yellow 200', value: '#FEF08A' },

  // Greens
  { id: 16, name: 'Green 900', value: '#14532D' },
  { id: 17, name: 'Green 600', value: '#16A34A' },
  { id: 18, name: 'Green 300', value: '#86EFAC' },

  // Teals
  { id: 19, name: 'Teal 900', value: '#134E4A' },
  { id: 20, name: 'Teal 600', value: '#0D9488' },
  { id: 21, name: 'Teal 300', value: '#5EEAD4' },

  // Blues
  { id: 22, name: 'Blue 900', value: '#1E3A5F' },
  { id: 23, name: 'Blue 600', value: '#2563EB' },
  { id: 24, name: 'Blue 300', value: '#93C5FD' },

  // Indigos
  { id: 25, name: 'Indigo 900', value: '#312E81' },
  { id: 26, name: 'Indigo 600', value: '#4F46E5' },
  { id: 27, name: 'Indigo 300', value: '#A5B4FC' },

  // Purples
  { id: 28, name: 'Purple 900', value: '#4A1D96' },
  { id: 29, name: 'Purple 600', value: '#9333EA' },
  { id: 30, name: 'Purple 300', value: '#D8B4FE' },

  // Pinks
  { id: 31, name: 'Pink 900', value: '#831843' },
  { id: 32, name: 'Pink 600', value: '#DB2777' },
  { id: 33, name: 'Pink 300', value: '#F9A8D4' },
];
